var React = require('react');

function Repeat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M17.351 5.43c.42.78.656 1.67.649 2.612-.023 3.04-2.582 5.475-5.681 5.475H6.75v1.638c0 .775-.92 1.112-1.44.602L2.497 13a.816.816 0 0 1 0-1.17L5.31 9.07c.53-.52 1.44-.15 1.44.585v1.655h5.585c1.857 0 3.396-1.454 3.415-3.275a3.238 3.238 0 0 0-.324-1.45.814.814 0 0 1 .168-.94l.418-.407c.4-.391 1.075-.297 1.34.192zm-15.1 2.536C2.268 6.145 3.807 4.69 5.664 4.69h5.585v1.638c0 .772.918 1.114 1.44.602l2.813-2.758a.816.816 0 0 0 0-1.17L12.69.243c-.525-.515-1.44-.164-1.44.604v1.637H5.681c-3.1 0-5.658 2.435-5.68 5.475a5.397 5.397 0 0 0 .648 2.611c.264.49.94.584 1.339.192l.418-.406a.815.815 0 0 0 .168-.94 3.237 3.237 0 0 1-.324-1.45z"}));
}

Repeat.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16"};

module.exports = Repeat;

Repeat.default = Repeat;
